import { useEffect, useRef, useState, type FC, type PropsWithChildren } from "react";
import classNames from "classnames";
import { AppTooltip, type AppTooltipProps } from "../AppTooltip";
import styles from "./styles.module.scss";

type Props = {
  showTooltip?: boolean;
  className?: string;
  tooltipProps?: AppTooltipProps;
};

export const EllipsisWrapper: FC<PropsWithChildren<Props>> = ({
  showTooltip = true,
  children,
  tooltipProps,
  className,
}) => {
  const tooltipContentWrapperRef = useRef<HTMLDivElement | null>(null);
  const tooltipContentRef = useRef<HTMLDivElement | null>(null);
  const [contentOverflow, setContentOverflow] = useState<boolean>(true);

  useEffect(() => {
    const contentIsOverflow =
      Number(tooltipContentRef.current?.offsetWidth) >
      Number(tooltipContentWrapperRef.current?.offsetWidth);
    setContentOverflow(contentIsOverflow);
  }, [tooltipContentWrapperRef.current, tooltipContentRef.current, children]);

  if (!showTooltip) return <>{children}</>;
  return (
    <AppTooltip
      placement="bottomRight"
      classNames={{ root: styles["tooltip-ellipsis"] }}
      {...(!contentOverflow && { open: false })}
      title={children}
      {...tooltipProps}
    >
      <div ref={tooltipContentWrapperRef} className={styles["tooltip-content-wrapper"]}>
        <span ref={tooltipContentRef} className={classNames(styles["tooltip-content"], className)}>
          {children}
        </span>
      </div>
    </AppTooltip>
  );
};
